import { useState } from 'react';
import { Grid, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@material-ui/core';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const validateRoutingNumber = routingNumber => {
  if (routingNumber.length === 9) {
    const d1 = parseInt(routingNumber[0]);
    const d2 = parseInt(routingNumber[1]);
    const d3 = parseInt(routingNumber[2]);
    const d4 = parseInt(routingNumber[3]);
    const d5 = parseInt(routingNumber[4]);
    const d6 = parseInt(routingNumber[5]);
    const d7 = parseInt(routingNumber[6]);
    const d8 = parseInt(routingNumber[7]);
    const d9 = parseInt(routingNumber[8]);
    const checksum = 3 * (d1 + d4 + d7) + 7 * (d2 + d5 + d8) + (d3 + d6 + d9);
    if (checksum % 10 === 0) {
      return null;
    } else {
      return 'Incorrect routing number';
    }
  } else {
    return 'Routing number must be 9 characters long';
  }
};
export const BankAccountDetailsModal = _ref => {
  let {
    open,
    onCancel,
    onSubmit
  } = _ref;
  const [routingNumber, setRoutingNumber] = useState('');
  const [accountNumber, setAccountNumber] = useState('');
  const [routingNumberError, setRoutingNumberError] = useState(null);
  const [accountNumberError, setAccountNumberError] = useState(null);
  const handleRoutingNumberChange = event => {
    const value = event.target.value;
    setRoutingNumber(value);
    setRoutingNumberError(validateRoutingNumber(value));
  };
  const handleAccountNumberChange = event => {
    const value = event.target.value;
    setAccountNumber(value);
    setAccountNumberError(value ? null : 'Empty account number');
  };
  const handleSubmit = () => {
    const routingError = validateRoutingNumber(routingNumber);
    if (routingError) {
      setRoutingNumberError(routingError);
    }
    if (accountNumber === '') {
      setAccountNumberError('Empty account number');
    }
    if (!routingError && accountNumber !== '') {
      onSubmit({
        routingNumber,
        accountNumber
      });
    }
  };
  return /*#__PURE__*/_jsxs(Dialog, {
    fullWidth: true,
    maxWidth: "sm",
    open: open,
    children: [/*#__PURE__*/_jsx(DialogTitle, {
      children: "Bank Account Details"
    }), /*#__PURE__*/_jsx(DialogContent, {
      children: /*#__PURE__*/_jsx(Grid, {
        container: true,
        direction: "column",
        spacing: 2,
        children: /*#__PURE__*/_jsxs(Grid, {
          container: true,
          item: true,
          direction: "column",
          justify: "center",
          alignItems: "stretch",
          spacing: 2,
          children: [/*#__PURE__*/_jsx(Grid, {
            item: true,
            children: /*#__PURE__*/_jsx(TextField, {
              required: true,
              fullWidth: true,
              variant: "standard",
              label: "Routing Number",
              inputProps: {
                'data-testid': 'bank-account-routing-number-input'
              },
              value: routingNumber,
              error: routingNumberError !== null,
              helperText: routingNumberError !== null && routingNumberError !== void 0 ? routingNumberError : '',
              onBlur: handleRoutingNumberChange,
              onChange: handleRoutingNumberChange
            })
          }), /*#__PURE__*/_jsx(Grid, {
            item: true,
            children: /*#__PURE__*/_jsx(TextField, {
              required: true,
              fullWidth: true,
              variant: "standard",
              label: "Account Number",
              inputProps: {
                'data-testid': 'bank-account-account-number-input'
              },
              value: accountNumber,
              error: accountNumberError !== null,
              helperText: accountNumberError !== null && accountNumberError !== void 0 ? accountNumberError : '',
              onBlur: handleAccountNumberChange,
              onChange: handleAccountNumberChange
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsxs(DialogActions, {
      children: [/*#__PURE__*/_jsx(Button, {
        variant: "text",
        color: "primary",
        onClick: onCancel,
        children: "Cancel"
      }), /*#__PURE__*/_jsx(Button, {
        variant: "contained",
        color: "primary",
        "data-testid": "bank-account-submit-button",
        disabled: routingNumberError !== null || accountNumberError !== null,
        onClick: handleSubmit,
        children: "Submit"
      })]
    })]
  });
};